import { Component, inject, Input } from '@angular/core';
import { Photo } from '@models/photo';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PhotoTaken } from 'src/app/interfaces/photo-taken.interface';
import { CommonModule } from '@angular/common';
import { SessionRetakeRequestFormItemComponent } from '../session-retake-request-form-item/session-retake-request-form-item.component';
import { RetakeRequest, Session } from 'src/app/queries/generated';
import { SessionsService } from '@services/sessions.service';

@Component({
  selector: 'lv-session-retake-request-form',
  templateUrl: './session-retake-request-form.component.html',
  styleUrls: ['./session-retake-request-form.component.scss'],
  imports: [CommonModule, TranslateModule, SessionRetakeRequestFormItemComponent]
})
export class SessionRetakeRequestFormComponent {
  private sessionsService = inject(SessionsService);
  private translateService = inject(TranslateService);

  @Input() session!: Session;
  @Input() token!: string;
  @Input() retakeRequest!: RetakeRequest;

  facePhotoReady = false;
  idPhotoReady = false;
  facePhoto: Photo;
  idPhoto: Photo;

  pluralizedTranslationFor(item: string): string {
    const fullRequest = this.retakeRequest?.facePhoto && this.retakeRequest?.idPhoto;
    const key = fullRequest ? 'many' : 'one';

    return this.translateService.instant(`session-retake-request-form.component.${item}.${key}`);
  }

  onPhotoTaken(photoTaken: PhotoTaken) {
    const key = `${photoTaken.photoType}Photo`;

    this[key] = photoTaken.photo;
    this[`${key}Ready`] = true;
  }

  onSubmit() {
    this.sessionsService.retakePhotos(this.prepareRetakePhotosInput()).subscribe({
      error: (error) => console.error('failed updating identification', error)
    });
  }

  private prepareRetakePhotosInput() {
    const input = {
      token: this.token,
      retakePhotos: {}
    };

    if (this.facePhoto) {
      input.retakePhotos['facePhoto'] = this.sanitizePhotoPayload(this.facePhoto);
    }

    if (this.idPhoto) {
      input.retakePhotos['idPhoto'] = this.sanitizePhotoPayload(this.idPhoto);
    }

    return input;
  }

  private sanitizePhotoPayload(photo: Photo) {
    const payload = photo.payload;
    const { path, geometry, bytes, signature } = payload;
    const content_type = payload['content_type'];

    return { contentType: content_type, path, geometry, bytes, signature };
  }
}
